<template>
  <ul class="steps" :ref="'steps' + idNav" :id="idNav">
    <step-item @click="selectStep(item.idStep)" v-for="(item, index) in items" :position="(index+1)" :classes="itemClass" v-bind="item" :done="selectedItemIndex > index" :selected="selectedItemIndex == index" />
  </ul>
  <div class="step-content px-4 pt-6 pb-6 mt-6 border-t" :id="idContent">
    <step-content v-for="(item, index) in items" v-bind="item" :selected="selectedItemIndex == index">
      <template #content v-if="hasSlot('content.' + item.idStep)">
        <slot :key="'content.' + item.idStep" :name="'content.' + item.idStep" />
      </template>
    </step-content>
  </div>
  <div class="flex justify-end">
    <button v-if="selectedItemIndex < (items.length - 1)" type="button" class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="cancel">Cancelar</button>
    <button v-if="selectedItemIndex < (items.length - 1)" type="button" :disabled="selectedItemIndex == 0" class="px-6 py-2.5 bg-sky-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md ml-1 hover:bg-sky-700 hover:shadow-lg focus:bg-sky-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-sky-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="back">Voltar</button>
    <loading-button v-if="selectedItemIndex < (items.length - 1)" :loading="processing" class="btn-blue px-6 py-2.5 text-xs leading-tight uppercase ml-1" @click.prevent="next" type="button">Próximo</loading-button>
    <button v-if="selectedItemIndex == (items.length - 1)" type="button" class="px-6 py-2.5 bg-blue-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md ml-1 hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="cancel">Finalizar</button>
  </div>
</template>

<script>
import { ref } from 'vue';
import { v4 as uuid } from 'uuid'
import StepItem from '@/Shared/Steps/StepItem'
import StepContent from '@/Shared/Steps/StepContent'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    StepItem,
    StepContent,
    LoadingButton,
  },
  props: {
    idNav: {
      type: String,
      default() {
        return `steps-step-${uuid()}`
      },
    },
    idContent: {
      type: String,
      default() {
        return `steps-stepContent-${uuid()}`
      },
    },
    selectedItemIndex: {
      type: Number,
      default: 0,
    },
    itemClass: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default() {
        return [
          {
            idStep: 'step-default',
            title: 'STEP',
            content: 'CONTENT',
            submitCallback: {
              type: Function,
              default: () => {}
            }
          }
        ]
      },
    },
    item: {
        type: Object,
        default: {
            errors: {}
        }
    },
    processing: {
        type: Boolean,
        default: false
    },
  },
  data() {
    return {
      selectedStep: null
    }
  },
  setup(props, context) {
      const selectedItemIndex = ref(props.selectedItemIndex);
      const processing = ref(props.processing);

      return {
          selectedItemIndex,
          processing,
      }
  },
  emits: ['cancel'],
  methods: {
    back() {
      this.selectedItemIndex -= 1;
    },
    next() {
      this.processing = true;
      let selectItem = this.items[this.selectedItemIndex];
      
      if(typeof(selectItem.submitCallback) == 'function') {
        selectItem.submitCallback(this.item, (success) => {
          if(success) {
            this.selectedItemIndex += 1;
          }
          this.processing = false;
        });
      } else {
        this.selectedItemIndex += 1;
        this.processing = false;
      }
    },
    cancel() {
      this.$emit('cancel');
    },
    hasSlot(name = 'default') {
      return !!this.$slots[name];
    },
    selectStep: function (step) {
      this.selectedStep = step;
    },
  },
  mounted() {
    this.selectedStep = this.$refs['steps' + this.idNav].querySelector('.active').id.replace('steps-', '').replace('-step', '');
  },
  watch: {
    selectedStep(value_new, value_old) {
      //console.log('this.selectedStep');
      //console.log(this.selectedStep);
    },
  }
}
</script>
<style>
ul.steps {
  @apply flex justify-center;
}
ul.steps li {
  @apply flex flex-wrap flex-col items-center relative text-sm w-full before:h-1;
}
ul.steps li:not(:first-child) {
  @apply before:content-[''] before:relative before:left-[calc(-50%)] before:top-[16px] before:w-[calc(100%-25px)] before:h-1 before:bg-gray-500;
}
ul.steps li div.dot {
  @apply flex justify-center items-center border-2 border-gray-500 w-7 h-7 rounded-full text-gray-500 font-bold;
}
ul.steps li div.title {
  @apply text-xs text-center hidden sm:block;
}
ul.steps li.active,
ul.steps li.done {
  @apply before:bg-blue-500;
}
ul.steps li.active div.dot,
ul.steps li.done div.dot {
  @apply bg-blue-500 text-white border-none;
}
button:disabled {
  @apply opacity-50 cursor-not-allowed;
}
</style>
